import "./styles.scss";

import { useTranslation } from "react-i18next";

import { useApp } from "context/app";
import TasksProvider from "context/admin/tasks";

import Button from "components/Button";
import { CreateTaskModal } from "page_components/admin/modals";

const CreateTask = () => {
  const { t } = useTranslation();

  const { create_task_open, setCreateTaskOpen } = useApp();

  return (
    <TasksProvider>
      <div>
        <Button onClick={() => setCreateTaskOpen(true)}>
          {t("Create new task")}
        </Button>
      </div>
      <CreateTaskModal
        isOpen={create_task_open}
        onClose={() => setCreateTaskOpen(false)}
      />
    </TasksProvider>
  );
};

export default CreateTask;
